export function updateConfigBaseUrl({
    config,
    baseUrl,
}: {
    config: any;
    baseUrl: string;
}) {
    Object.keys(config.domains).forEach((domainName) => {
        config.domains[domainName].baseUrl = baseUrl;
    });
}
